import type { ReactNode } from 'react';

/**
 * Standard page header with the Sentinel-style italic-serif accent.
 * Usage:
 *   <PageHeader title="Stores" accent="connected" sub="Manage every platform..." />
 * Renders:  Stores connected   (where "connected" is in Instrument Serif italic)
 */
export function PageHeader({
  title,
  accent,
  sub,
  actions,
  icon,
}: {
  title: string;
  accent?: string;
  sub?: ReactNode;
  actions?: ReactNode;
  icon?: ReactNode;
}): JSX.Element {
  return (
    <div
      className="fade-in"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 24,
        marginBottom: 24,
      }}
    >
      <div style={{ minWidth: 0 }}>
        <h1
          style={{
            fontSize: 22,
            fontWeight: 500,
            margin: 0,
            marginBottom: 4,
            letterSpacing: '-0.025em',
            lineHeight: 1.2,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          {icon}
          <span>
            {title}
            {accent && (
              <em
                style={{
                  fontStyle: 'italic',
                  fontFamily: 'var(--font-serif)',
                  fontWeight: 400,
                  color: 'var(--text-muted)',
                  marginLeft: 8,
                }}
              >
                {accent}
              </em>
            )}
          </span>
        </h1>
        {sub && (
          <div
            style={{
              color: 'var(--text-muted)',
              fontSize: 12,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            {sub}
          </div>
        )}
      </div>
      {actions && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          {actions}
        </div>
      )}
    </div>
  );
}
